import React, { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";

import Medal from "../../../components/Medal";
import { FaSignal } from "react-icons/fa";
// import { FaExclamation } from 'react-icons/fa';

import { getModeIcon, getModeNameCapitalFirst } from "../../../util/util";
// import { useGamePlay } from "../../../ducks/gamePlay";
// import { useLeagues } from "../../../ducks/leagues";
import { FaStar } from "react-icons/fa";
import {
  LeagueResult,
  LEAGUE_IDS,
  LEAGUE_LIMITS,
  LEAGUE_NAME_PLACEMENT,
  MIN_GAME_NR_PER_LEAGUE,
} from "@chesshotel/constants";
import { FaExclamation } from "react-icons/fa";
import { gaEvent } from "../../../lib/ga";
import { useUser } from "../../../ducks/user";
// import { IoClose } from 'react-icons/io5';
import { useRouter } from "next/router";
import { useSize } from "../../../hooks/useSize";
import { LeagueScoreResult } from "@chesshotel/types";
import { useFeatureValue } from "@growthbook/growthbook-react";
// import { useUser } from "../../../ducks/user";
// import { IoClose } from 'react-icons/io5';
// import router from "next/router";
// import { gaEvent } from "../../../lib/ga";

const MAX_Difficulty = 30;
const MAX_PIECES = 30;

const FREQ = 1 / 1000;

function easeInOutQuad(t: number) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function animate(goal: number, updateFn: (val: number) => void) {
  const startTime = performance.now();
  loop();

  function loop() {
    const rest = (performance.now() - startTime) * FREQ;

    if (rest < 1) {
      const ease = easeInOutQuad(rest);
      updateFn(Math.round(ease * goal));

      requestAnimationFrame(loop);
    } else {
      updateFn(goal);
    }
  }
}

interface Props {
  leagueScoreResult: LeagueScoreResult;
}

export default function Standard(props: Props) {
  const { leagueScoreResult } = props;
  const {
    leagueResult,
    leagueScore,
    rank,
    piecePoints,
    eloDiff,
    bonusPoolDiff,
  } = leagueScoreResult;
  const { modeId, leagueName, elo, points, gameNr } = leagueScore;

  const previousElo = elo + eloDiff;

  // const {
  //   // rank,
  //   // leagueName,
  //   // modeId,
  //   // bonusPool,
  //   // bonusPoolDiff,
  //   leagueScores,
  //   // leagueResult,
  // } = useLeagues();

  const { isGuest, username } = useUser();
  const router = useRouter();

  // const { elo, previousElo } = useGamePlay();
  const isDesktop = useSize();

  const { t } = useTranslation("common");
  const nextLeagueId = LEAGUE_IDS[leagueName] + 1;
  const leagueLimit = LEAGUE_LIMITS[nextLeagueId];

  const saveProgressRate = useFeatureValue("save-progress", 1);

  // const currentLeagueScores = leagueScores[modeId + 1];

  // const { gameNr, points } = currentLeagueScores;

  let diffTag;

  if (eloDiff <= 0) {
    diffTag = `${eloDiff}`;
  } else {
    diffTag = `+${eloDiff}`;
  }

  const [pointsNum, setPointsNum] = useState(0);
  const [difficultyNum, setDifficultyNum] = useState(null);
  const [difficultyProc, setDifficultyProc] = useState(0);
  const [bonusNum, setBonusNum] = useState(null);
  const [bonusProc, setBonusProc] = useState(0);
  const [pieceNum, setPieceNum] = useState(null);
  const [pieceProc, setPieceProc] = useState(0);

  const [nextLeagueNum, setNextLeagueNum] = useState(0);
  const [nextLeagueProc, setNextLeagueProc] = useState(0);

  // const [showSignUpBanner, setShowSignUpBanner] = useState(true);

  // const [bonusPoolNum, setBonusPoolNum] = useState(0);
  const bonusPointsEarned = Math.abs(bonusPoolDiff);

  function animateDifficulty(time) {
    setTimeout(() => {
      animate(eloDiff, setDifficultyNum);
      const proc = Math.min(Math.round((eloDiff * 100) / MAX_Difficulty), 100);
      setDifficultyProc(proc);
    }, time);
  }

  function animateBonus(time) {
    setTimeout(() => {
      animate(bonusPointsEarned, setBonusNum);
      const proc = Math.min(
        Math.round((bonusPointsEarned * 100) / MAX_Difficulty),
        100
      );
      setBonusProc(proc);
    }, time);
  }

  function animatePieces(time) {
    if (piecePoints === 0) {
      return;
    }
    setTimeout(() => {
      animate(piecePoints, setPieceNum);
      setPieceProc(Math.round((piecePoints * 100) / MAX_PIECES));
    }, time);
  }

  function animateNextLeague(time) {
    if (leagueName === LEAGUE_NAME_PLACEMENT) {
      setTimeout(() => {
        animate(gameNr, setNextLeagueNum);
        setNextLeagueProc((gameNr * 100) / 5);
      }, time);
    } else if (!leagueLimit) {
      return;
    } else {
      setTimeout(() => {
        const gameNrProc = Math.min(gameNr / MIN_GAME_NR_PER_LEAGUE, 1) * 50;
        const eloLimitProc = (previousElo * 50) / leagueLimit;
        const proc = Math.min(Math.round(gameNrProc + eloLimitProc), 99);
        animate(proc, setNextLeagueNum);
        setNextLeagueProc(proc);
      }, time);
    }
  }

  useEffect(() => {
    if (eloDiff > 0) {
      animateDifficulty(500);
      animateBonus(1200);
      animatePieces(1900);
      animateNextLeague(2600);
    } else {
      animatePieces(500);
      animateNextLeague(1200);
    }
  }, []);

  useEffect(() => {
    if (eloDiff > 0) {
      const sum = pieceNum + difficultyNum + bonusNum;
      sum != null && setPointsNum(sum);
    } else {
      pieceNum != null && setPointsNum(pieceNum);
    }
  }, [pieceNum, difficultyNum, bonusNum]);

  // useEffect(() => {
  //   if (leagueResult === LeagueResult.UPGRADE) {
  //     setShowSignUpBanner(true);
  //   }
  // }, [leagueResult]);

  function renderStats() {
    return (
      <div className="flex flex-col w-full">
        <div className="flex items-start justify-around w-full p-4 border-altgray-100">
          <div className="flex items-center mr-0.5">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm text-red-500 rounded-full md:text-xl md:w-10 md:h-10 bg-altgray-100">
              <FaSignal />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-3">
              <div className="flex items-center">
                <div className="text-sm font-semibold md:text-lg">{elo}</div>{" "}
                <div className="ml-1 text-xs md:text-sm">{diffTag}</div>
              </div>
              <div className="text-xs md:text-sm">{t("Rating")}</div>
            </div>
          </div>

          <div className="flex items-center ml-0.5">
            <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm text-red-300 rounded-full md:w-10 md:h-10 bg-altgray-100 md:text-xl">
              <FaStar />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-3">
              <div className="flex items-center">
                <div className="text-sm font-semibold md:text-lg">
                  {pointsNum}
                </div>
              </div>
              <div className="text-xs md:text-sm">
                {isDesktop ? t("Points earned") : t("Points")}
              </div>
            </div>
          </div>
        </div>
        <div className="p-2">
          <table className="text-xs border-0 table-auto md:text-sm ">
            <colgroup>
              <col width="1%" />
              <col width="99%" />
              <col width="1%" />
            </colgroup>
            <tbody>
              {eloDiff > 0 && (
                <tr>
                  <td className="pr-2 text-right whitespace-nowrap">
                    {t("Difficulty")}
                  </td>
                  <td>
                    <div className="flex items-center bg-altgray-50 w-full rounded-sm h-5 my-0.5 font-semibold">
                      <div
                        className="flex items-center justify-end h-full overflow-hidden bg-red-100 rounded-sm bar-anim"
                        style={{
                          width: difficultyProc + "%",
                        }}
                      >
                        {eloDiff > 5 && (
                          <div className="mr-1 text-red-300">
                            {difficultyNum}
                          </div>
                        )}
                      </div>
                      {eloDiff <= 5 && (
                        <div className="ml-1 text-red-300">{difficultyNum}</div>
                      )}
                    </div>
                  </td>
                </tr>
              )}
              {bonusPointsEarned > 0 && (
                <tr>
                  <td className="pr-2 text-right whitespace-nowrap">
                    {t("Bonus points")}
                  </td>
                  <td>
                    <div className="flex items-center bg-altgray-50 w-full rounded-sm h-5 my-0.5 font-semibold">
                      <div
                        className="flex items-center justify-end h-full overflow-hidden bg-red-100 rounded-sm bar-anim"
                        style={{
                          width: bonusProc + "%",
                        }}
                      >
                        {bonusPointsEarned > 1 && (
                          <div className="mr-1 text-red-300">{bonusNum}</div>
                        )}
                      </div>
                      {bonusPointsEarned <= 1 && (
                        <div className="ml-1 text-red-300">{bonusNum}</div>
                      )}
                    </div>
                  </td>
                </tr>
              )}

              <tr>
                <td className="pr-2 text-right whitespace-nowrap">
                  {t("Taken pieces")}
                </td>
                <td>
                  <div className="flex items-center bg-altgray-50 w-full rounded-sm h-5 my-0.5 font-semibold">
                    <div
                      className="flex items-center justify-end h-full overflow-hidden bg-red-100 rounded-sm bar-anim"
                      style={{
                        width: pieceProc + "%",
                      }}
                    >
                      {piecePoints > 1 && (
                        <div className="mr-1 text-red-300">{pieceNum}</div>
                      )}
                    </div>
                    {piecePoints <= 1 && (
                      <div className="ml-1 text-red-300">{pieceNum}</div>
                    )}
                  </div>
                </td>
              </tr>

              {
                <tr>
                  <td colSpan={3} className="h-2"></td>
                </tr>
              }
              {leagueLimit && (
                <tr>
                  <td className="pr-2 text-right whitespace-nowrap">
                    {t("League promotion")}
                  </td>
                  <td>
                    <div
                      className={`bg-altgray-50 w-full rounded-sm h-5 my-0.5 font-semibold`}
                    >
                      <div
                        className={`flex items-center h-full justify-end overflow-hidden bg-red-400 rounded-sm bar-anim
                          `}
                        style={{
                          width: nextLeagueProc + "%",
                        }}
                      >
                        <div className="mr-1 text-red-100">
                          {nextLeagueNum + "%"}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {leagueName === LEAGUE_NAME_PLACEMENT && (
                <tr>
                  <td className="pr-2 text-right whitespace-nowrap">
                    {t("Placement game")}
                  </td>
                  <td colSpan={2}>
                    <div
                      className={`bg-altgray-50 w-full rounded-sm h-5 my-0.5 font-semibold`}
                    >
                      <div
                        className={`flex items-center h-full justify-end overflow-hidden bg-red-400 rounded-sm bar-anim
                        `}
                        style={{
                          width: nextLeagueProc + "%",
                        }}
                      >
                        <div className="mr-1 text-red-100">{nextLeagueNum}</div>
                      </div>
                    </div>
                  </td>
                  <td className="pl-1">5</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  function renderMedal() {
    if (leagueName !== LEAGUE_NAME_PLACEMENT) {
      return (
        <div>
          <Medal
            rank={rank}
            title="RANK"
            leagueName={leagueName}
            size={isDesktop ? "large" : "medium"}
          />
        </div>
      );
    }
  }

  function renderTotalPoints() {
    return (
      <div className="absolute top-0 right-0 flex pr-1 text-xs rounded-bl-xl bg-altgray-50">
        <div className="flex items-center pb-1 pt-0.5 md:py-1.5 px-1 md:px-1.5 space-x-0 md:space-x-1">
          <div className="flex items-center justify-center text-sm text-red-300 rounded-full w-7 h-7">
            <FaStar />
          </div>
          <div className="flex flex-col">
            <div className="text-sm font-semibold">{points}</div>
            {isDesktop && <div className="text-xs -mt-0.5">{t("Points")}</div>}
          </div>
        </div>
      </div>
    );
  }

  function signUpBanner() {
    return (
      <div className="flex items-center justify-center w-full pt-5 pb-5 border-t bg-altblue-500">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => {
              gaEvent({
                category: "SignUpBanner",
                action: "Sign up",
                label: username,
              });
              router.push("/register");
            }}
            className="px-6 py-3 text-xs text-altblue-500 btn btn-outline md:text-sm"
          >
            {t("Sign up to save your progress")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="relative flex flex-col w-full px-3 py-8 md:pl-8 md:pr-10">
        {renderTotalPoints()}
        <div
          className={`flex space-x-2 items-center justify-center uppercase text-base md:text-xl font-bold mb-3
     `}
        >
          <div className="flex items-center">
            <div>{getModeIcon(modeId)}</div>
            <div className="ml-1">{getModeNameCapitalFirst(modeId, t)}</div>
          </div>
          <div>
            {leagueName !== LEAGUE_NAME_PLACEMENT
              ? t(leagueName + " league")
              : t("Placement game")}
          </div>
        </div>
        <div
          className={`flex items-center space-x-1 md:space-x-3 ${
            leagueName === LEAGUE_NAME_PLACEMENT
              ? "w-full md:w-3/4 self-center"
              : ""
          }`}
        >
          {renderMedal()}
          {renderStats()}
        </div>
      </div>

      {isGuest &&
        gameNr >= 5 &&
        (gameNr - 5) % saveProgressRate == 0 &&
        signUpBanner()}
    </>
  );
}
